import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractFullMessages } from '@/utils/extract'
import { AGENCY_QUOTATION_INIT_LOADING, AGENCY_QUOTATION_INIT_SUCCESS, AGENCY_QUOTATION_INIT_FAIL, QUOTE_CARGO_PARAM, QUOTE_CARGO_PARAM_CLAUSE, QUOTE_CARGO_GENERAL, QUOTE_CARGO_DEFCLAUSE, QUOTE_CARGO_PARAM_DEFCLAUSE, QUOTE_CARGO_PARAM_DEFCLAUSE_LOADING, QUOTE_CARGO_PARAM_DEFCLAUSE_FAIL, AGENCY_QUOTATION_PREM_LOADING, AGENCY_QUOTATION_PREM_SUCCESS, AGENCY_QUOTATION_PREM_FAIL, AGENCY_QUOTATION_SAVE_LOADING, AGENCY_QUOTATION_SAVE_SUCCESS, AGENCY_QUOTATION_SAVE_FAIL } from '@/store/types'

export const cargo = {
  async cargoQuoteInit({ commit, state }) {
    const expand = {
      intermediary: state.quotation.commonForm.intermediary
    }
    const apiUrl = expandURI(state.quotationSettings.menu.cargo, expand)

    commit(AGENCY_QUOTATION_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(AGENCY_QUOTATION_INIT_SUCCESS, commitResult)
        if (commitResult.hasContent) {
          commit(QUOTE_CARGO_PARAM, commitResult.data)
        }
      } catch (error) {
        commit(AGENCY_QUOTATION_INIT_FAIL)
      }
    } else {
      commit(AGENCY_QUOTATION_INIT_FAIL, ['Invalid API URL'])
    }
  },
  cargoQuoteGeneral({ commit, state, dispatch }, data) {
    // Before committing the data, we will check what is affected by the change of cargoQuoteGeneral fields
    const quoteForm = state.quotation.cargoForm
    // Check if there is a change of busCls
    if (!quoteForm.busCls || quoteForm.busCls !== data.busCls) {
      commit(QUOTE_CARGO_PARAM_CLAUSE, false)
    }
    // Commit the data
    commit(QUOTE_CARGO_GENERAL, data)
  },
  async cargoQuoteClause({ commit, state }, { cover }) {
    const expand = {
      cvrType: cover
    }
    const apiUrl = expandURI(state.quotation.menu.defClause, expand)
    if (apiUrl) {
      try {
        commit(QUOTE_CARGO_PARAM_DEFCLAUSE_LOADING)
        const result = await http.get(apiUrl)
        const { data } = result
        if (data.hasContent) {
          commit(QUOTE_CARGO_PARAM_DEFCLAUSE, data.data)
          if (state.quotation.cargoParam && state.quotation.cargoParam.clause.length > 0) {
            const commitClause = []
            for (let clauseParam of state.quotation.cargoParam.clause) {
              // Check existing
              let exist = false
              if (state.quotation.cargoParam.clause && state.quotation.cargoParam.clause.length > 0) {
                for (let clauseForm of state.quotation.cargoParam.clause) {
                  if (clauseForm.value === clauseParam.value) {
                    commitClause.push(clauseForm)
                    exist = true
                    break
                  }
                }
              }
              // Def and addable
              if (!exist) {
                commitClause.push({
                  value: clauseParam.value,
                  secondaryValue: clauseParam.secondaryValue,
                  label: clauseParam.label
                })
              }
            }
            commit(QUOTE_CARGO_DEFCLAUSE, commitClause)
          } else {
            commit(QUOTE_CARGO_DEFCLAUSE, [])
          }
        } else {
          commit(QUOTE_CARGO_PARAM_DEFCLAUSE, [])
          commit(QUOTE_CARGO_DEFCLAUSE, [])
        }
      } catch (error) {
        console.log(error)
        commit(QUOTE_CARGO_PARAM_DEFCLAUSE_FAIL)
      }
    } else {
      commit(QUOTE_CARGO_PARAM_DEFCLAUSE_FAIL)
    }
  },
  async cargoQuoteCalculate({ commit, state }) {
    const apiUrl = state.quotation.menu.getPremium
    if (apiUrl) {
      try {
        commit(AGENCY_QUOTATION_PREM_LOADING)
        const { commonForm, cargoForm } = state.quotation
        // Compile the premium object
        const calculateObj = {
          appID: commonForm.appID,
          intermediary: commonForm.intermediary,
          product: commonForm.product,
          busCls: cargoForm.busCls,
          tariff: cargoForm.tariff,
          startDate: commonForm.startDate,
          endDate: commonForm.endDate,
          acceptDate: commonForm.acceptDate,
          siDeclared: cargoForm.siDeclared,
          manualRate: cargoForm.manualRate,
          campaign: commonForm.campaign,
          promotion: commonForm.promotion,
          adjDiscount: commonForm.adjDiscount,
          siCurrRate: cargoForm.siCurrRate,
          billCurrRate: commonForm.billCurrRate
        }
        const result = await http.post(apiUrl, calculateObj)
        commit(AGENCY_QUOTATION_PREM_SUCCESS, result.data)
      } catch (error) {
        commit(AGENCY_QUOTATION_PREM_FAIL, extractFullMessages(error))
      }
    } else {
      commit(AGENCY_QUOTATION_PREM_FAIL, ['Invalid API URL'])
    }
  },
  async revertCrgoQuote({ commit, state, dispatch }) {
    const apiUrl = state.quotation.menu.revertQuote
    if (apiUrl) {
      commit(AGENCY_QUOTATION_SAVE_LOADING)
      try {
        const submitForm = {
          proposalNo: state.quotation.commonForm.proposalNo,
          revision: state.quotation.commonForm.revision,
          appID: state.quotation.commonForm.appID
        }
        const result = await http.post(apiUrl, submitForm)
        // After success push to quotation page
        const dispatchObj = {
          proposalNo: result.data.proposalNo,
          query: false
        }
        await dispatch('loadQuote', dispatchObj)

        commit(AGENCY_QUOTATION_SAVE_SUCCESS)
      } catch (error) {
        if (error.response && error.response.data) {
          commit(AGENCY_QUOTATION_SAVE_FAIL, formatServerSaveError(error.response.data))
        } else {
          commit(AGENCY_QUOTATION_SAVE_FAIL, generateManualSaveError(['Fail to revert Quotation/Proposal Status to NQ']))
        }
        // Throw out the error, the component need to know if its success or not
        throw error
      }
    } else {
      commit(AGENCY_QUOTATION_SAVE_FAIL, generateManualSaveError(['Invalid API URL']))
      const err = { message: 'Invalid API URL' }
      throw err
    }
  }
}

/**
 * To put manual messages into saveError
 * @param {Array of String} msgs
 */
const generateManualSaveError = (msgs) => {
  if (msgs && msgs.length > 0) {
    return {
      fieldMessages: [],
      messages: msgs
    }
  } else {
    return {
      fieldMessages: [],
      messages: []
    }
  }
}

/**
 * Format server return object to dialog readable format
 * @param {Server return object data} data
 */
const formatServerSaveError = (data) => {
  let fieldMessages = []
  let messages = []

  if (data) {
    if (data.messages && data.messages.length > 0) {
      for (const err of data.messages) {
        messages.push(err.message)
      }
    }
    if (data.fieldMessages && data.fieldMessages.length > 0) {
      for (const err of data.fieldMessages) {
        fieldMessages.push(err.field + ': ' + err.message.message)
      }
    }
  }
  return {
    fieldMessages: fieldMessages,
    messages: messages
  }
}
